module.exports = __webpack_public_path__ + "img/0.b87948cf.jpg";